// src/components/PageMetaHiddenField.jsx
import React from 'react';

const PageMetaHiddenField = ({ meta, pageName }) => {
  if (!meta) return null;

  // Use pageName from meta object if available, otherwise use prop
  const effectivePageName = meta.pageName || pageName || 'Page';

  return (
    <textarea
      id={`${effectivePageName.replace(/\s+/g, '')}Meta_object`}
      hidden
      readOnly
      value={JSON.stringify(meta)}
      data-testid="page-meta-object"
    />
  );
};

export default PageMetaHiddenField;
